import { inject } from 'vue'
import {
  accessRolesCollectionKey,
  type AccessRolesCollectionService
} from '@gat-ship/types/injection-keys'

/**
 * Injects the access-roles collection that the admin shell provides (via
 * `AccessRolesCollectionProvider`) around the custom-fields route subtree.
 * Returns `undefined` when no provider is mounted above.
 *
 * The field-config cards read the role list through the `@gat-ship/types`
 * contract rather than importing `@gat-ship/access-control`, keeping
 * `@gat-ship/custom-fields` dependency-light for its many consumers.
 */
export function useAccessRoles(): AccessRolesCollectionService | undefined {
  return inject(accessRolesCollectionKey, undefined)
}
